/**
 * @file  loading/index.tsx
 * @description  component to show the loading spinner animation
 *
 * @author ogarcia (ozkary)
 *
 */
import React from 'react';
import * as S from './styles';
import { LoadingOutlined } from '@ant-design/icons';
import './styles.scss';

const Loading = (): JSX.Element => {
  const message = process.env.REACT_APP_LOADING || 'Loading...';

  return (
    <S.Container className="loading-container">
      <S.Icon className="loading-icon">
        <LoadingOutlined className="center-loading" />
        <S.Text className="container load-text">
          <S.Header className="load-text">{process.env.REACT_APP_TITLE}</S.Header>
          {message}
        </S.Text>
      </S.Icon>
    </S.Container>
  );
};

export default Loading;
